export default "__VITE_ASSET__BsOP_XVd__"